import { render } from "./AppStorePurchaseRegisterPaymentCallback.vue?vue&type=template&id=509adb45&scoped=true&ts=true"
import script from "./AppStorePurchaseRegisterPaymentCallback.vue?vue&type=script&lang=ts"
export * from "./AppStorePurchaseRegisterPaymentCallback.vue?vue&type=script&lang=ts"

import "./AppStorePurchaseRegisterPaymentCallback.vue?vue&type=style&index=0&id=509adb45&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509adb45"]])

export default __exports__